const addresses = [
  {
    city: "Москва",
    contact: {
      address: "ул. Кожевническая, д.16, стр. 4",
      coords: [55.728276, 37.64675],
      phone: "+7 (495) 959-55-45",
      email: "info@vodokomfort.ru",
    },
    representative: {
      name: "Шубин Владимир",
      phone: "+7 (916) 239-92-33",
      email: "v.shubin@vodokomfort.ru",
    },
  },
  {
    city: "Санкт-Петербург",
    contact: {
      address: "ул. Барочная, дом 10, корп 1, БЦ «Воронцовъ», 4 этаж, офис 406",
      coords: [59.967529, 30.288128],
      phone: "+7 (812) 612-21-11",
      email: "spb@vodokomfort.ru",
    },
    representative: null,
  },
  {
    city: "Екатеринбург",
    contact: {
      address:
        "ул. Сибирский тракт, д. 12, здание №8, вход №9, 4 этаж, офис 403",
      coords: [56.820035, 60.652227],
      phone: "+7 (343) 289-98-80",
      email: "ekb@vodokomfort.ru",
    },
    representative: null,
  },
  {
    city: "Челябинск",
    contact: {
      address:
        "ул. Молодогвардейцев, д. 7, корп. 3, БЦ «СигмаПартнер», 3 этаж, офис 353 ",
      coords: [55.203678, 61.327859],
      phone: "+7 (351) 214-75-77",
      email: "chlb@vodokomfort.ru",
    },
    representative: null,
  },
  {
    city: "Тюмень",
    contact: null,
    representative: {
      name: "Первушин Станислав",
      phone: "+7 (922) 396-08-88",
      email: "s.pervushin@vodokomfort.ru",
    },
  },
  {
    city: "Новосибирск",
    contact: {
      address: "ул. Ватутина, д. 99, оф. 403",
      coords: [54.967274, 82.933976],
      phone: "+7 (383) 316-37-77",
      email: "nvs@vodokomfort.ru",
    },
    representative: null,
  },
  {
    city: "Казань",
    contact: {
      address: "пр. Ямашева, д. 33Б, офис 501",
      coords: [55.826261, 49.109423],
      phone: "+7 (843) 254-54-70",
      email: "kzn@vodokomfort.ru",
    },
    representative: null,
  },
  {
    city: "Воронеж",
    contact: {
      address: "ул. Кольцовская, д. 35А, 15 этаж, офис 1501",
      coords: [51.667194, 39.191906],
      phone: "+7 (473) 210-07-10",
      email: "vrn@vodokomfort.ru",
    },
    representative: {
      name: "Шишкин Александр",
      phone: "+7 (910) 241-68-63",
      email: "a.shishkin@vodokomfort.ru",
    },
  },
  {
    city: "Краснодар",
    contact: {
      address: "ул. Красных Партизан, д. 559",
      coords: [45.048915, 38.973669],
      phone: "+7 (861) 997-00-11",
      email: "krd@vodokomfort.ru",
    },
    representative: null,
  },
  {
    city: "Хабаровск",
    contact: null,
    representative: {
      name: "Капитоненко Александра",
      phone: "+7 (966) 146-25-98",
      email: "a.kapitonenko@vodokomfort.ru",
    },
  },
  {
    city: "Владивосток",
    contact: null,
    representative: {
      name: "Ионов Владимир",
      phone: "+7 (902) 483-94-00",
      email: "v.ionov@vodokomfort.ru",
    },
  },
  {
    city: "Республика Узбекистан, Ташкент",
    contact: null,
    representative: {
      name: "Суслин Дамир",
      phone: "+998-93-555-14-52",
      email: "d.suslin@vodokomfort.ru",
    },
  },
];

export default addresses;
